import React from 'react';
import { CheckCircle, Sparkles } from 'lucide-react';
import { doctorInfo, aboutDoctor } from '../mockData';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-white via-cyan-50/30 to-purple-50/30 relative overflow-hidden">
      {/* Decorative blobs */}
      <div className="absolute top-20 right-20 w-64 h-64 bg-gradient-to-br from-purple-300/20 to-pink-300/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 left-20 w-80 h-80 bg-gradient-to-tr from-cyan-300/20 to-blue-300/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative group">
              {/* Gradient border effect */}
              <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 rounded-3xl blur opacity-75 group-hover:opacity-100 transition duration-500"></div>
              <div className="relative">
                <img
                  src={doctorInfo.aboutImage}
                  alt="Dr. Mitchell"
                  className="rounded-3xl shadow-2xl w-full h-[500px] object-cover relative"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-gradient-to-br from-cyan-500 via-blue-500 to-purple-600 text-white p-8 rounded-2xl shadow-2xl transform group-hover:scale-110 transition-transform duration-300">
                <Sparkles className="absolute top-2 right-2 h-6 w-6 animate-pulse" />
                <div className="text-5xl font-bold">{doctorInfo.yearsOfExperience}+</div>
                <div className="text-sm mt-1 font-medium">Years of Excellence</div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2 space-y-6">
            <div>
              <span className="text-transparent bg-gradient-to-r from-cyan-600 to-blue-600 bg-clip-text font-bold text-sm uppercase tracking-wider">About the Doctor</span>
              <h2 className="text-5xl font-bold bg-gradient-to-r from-gray-900 via-blue-800 to-purple-900 bg-clip-text text-transparent mt-2">Dedicated to Your Health & Wellness</h2>
            </div>

            <p className="text-gray-700 text-lg leading-relaxed">
              {aboutDoctor.bio}
            </p>

            <div className="bg-gradient-to-r from-cyan-50 to-blue-50 border-l-4 border-gradient-to-b from-cyan-500 to-blue-600 p-6 rounded-r-2xl shadow-lg">
              <p className="text-gray-800 italic font-medium">
                "{aboutDoctor.philosophy}"
              </p>
            </div>

            <div className="space-y-3">
              {aboutDoctor.highlights.map((highlight, index) => (
                <div key={index} className="flex items-start space-x-3 group">
                  <div className="bg-gradient-to-br from-cyan-500 to-blue-500 rounded-full p-1 flex-shrink-0 mt-0.5 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <CheckCircle className="h-5 w-5 text-white" />
                  </div>
                  <span className="text-gray-700 font-medium">{highlight}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;